export default __webpack_public_path__ + "static/media/place-icon.4ed9759f.svg";